import { defineStore } from "pinia";
import { ref } from "vue";

export const useGoogleStore = defineStore("google", () => {
  const googleDocuments = ref({
    lesson: {},
    assignment: {},
    attempt: {},
  });

  //for attempt side use only, to disable clear answer
  const processingGoogleFiles = ref([]);

  // Use to store the document id when the modal is open when duplication is done for editing team member.
  // To cater for scenario when document A is duplicating, and GoogleDuplicationWaitModal is opening for document B.
  const sourceDocumentIdInModal = ref("");

  const getGoogleDocument = (context, id) => {
    if (googleDocuments.value[context][id]) {
      return googleDocuments.value[context][id];
    }
  };
  const setGoogleDocument = (context, id, googleDocument) => {
    googleDocuments.value[context][id] = googleDocument;
  };

  const getGoogleDocumentByField = (context, id, field) => {
    if (googleDocuments.value[context][id]) {
      return googleDocuments.value[context][id][field];
    }
  };
  const setGoogleDocumentByField = (context, id, field, data) => {
    googleDocuments.value[context][id][field] = data;
  };
  const removeGoogleDocument = (context, id) => {
    delete googleDocuments.value[context][id];
  };

  const checkProcessingGoogleFilesByIdList = (idList) => {
    for (const id of idList) {
      if (processingGoogleFiles.value.includes(id)) {
        return true;
      }
    }
    return false;
  };

  const addProcessingGoogleFile = (id) => {
    processingGoogleFiles.value.push(id);
  };
  const removeProcessingGoogleFile = (id) => {
    const index = processingGoogleFiles.value.indexOf(id);
    if (index > -1) {
      processingGoogleFiles.value.splice(index, 1);
    }
  };

  const getSourceDocumentIdInModal = () => {
    return sourceDocumentIdInModal.value;
  };
  const setSourceDocumentIdInModal = (documentId) => {
    sourceDocumentIdInModal.value = documentId;
  };

  return {
    googleDocuments,
    getGoogleDocument,
    setGoogleDocument,
    getGoogleDocumentByField,
    setGoogleDocumentByField,
    removeGoogleDocument,
    checkProcessingGoogleFilesByIdList,
    addProcessingGoogleFile,
    removeProcessingGoogleFile,
    getSourceDocumentIdInModal,
    setSourceDocumentIdInModal,
  };
});
